<template>
  <div class="contributors">
    <section class="hero is-primary" v-if="categories">
    </section>
    <section class="section categories">
      <div v-if="categories" class="container categories">
           <div class="notification is-info">
          <p id= "teste">
            <span style="color: rgb(107, 240, 133);">         Argumentos opcionais:</span>
            <span style="margin-left: 5px;">[aparecem assim]</span>
            <span style="color: rgb(233, 105, 105);">              Argumentos obrigatórios:</span>
            <span style="margin-left: 5px;"> &lt;aparecem assim&gt;</span>
          </p>
           </div>
        
        <div v-for="category in filteredCommands" :key="category.name">
          <b-message
            v-if="category.commands.length"
            :title="`${category.displayName} (${category.commands.length})`"
            :closable="false"
            class="category">
            <b-message
              v-for="command in category.commands"
              :key="command.name"
              class="command">
              <p :href="'#' + command.name" class="command-usage">
                ;{{command.name}}
                <span
                  v-for="arg in getArgType(command.usage)"
                  :key="arg.arg">
                  <b-tooltip :label="'Argumento ' + arg.type">
                    <span :class="arg.type">{{arg.arg}}&ensp;</span>
                  </b-tooltip>
                </span>
              </p>
              <div v-if="command.aliases">
                <b>Alternativas</b>
                <span
                  v-for="aliase in command.aliases"
                  :key="aliase"
                  class="aliase">{{aliase}}</span>
              </div>
              <vue-markdown>{{command.description}}</vue-markdown>
              <div class="subcommands" v-if="command.subcommands">
                <b>Subcomandos</b>
                <div
                  class="subcommand"
                  v-for="subcmd in command.subcommands"
                  :key="subcmd.name">
                  <p class="command-usage">
                   ;{{subcmd.name}}
                    <span v-for="arg in getArgType(subcmd.usage)" :key="arg.arg">
                      <b-tooltip :label="'Argumento ' + arg.type">
                        <span :class="arg.type">{{arg.arg}}&ensp;</span>
                      </b-tooltip>
                    </span>
                  </p>
                  <div v-if="subcmd.aliases">
                    <b>Alternativas</b>
                    <span
                      v-for="aliase in subcmd.aliases"
                      :key="aliase"
                      class="aliase">{{aliase}}</span>
                  </div>
                  <vue-markdown>{{subcmd.description}}</vue-markdown>
                </div>
              </div>
            </b-message>
          </b-message>
        </div>
      </div>
    </section>
    <b-loading :active="!categories" />
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import _ from 'lodash'

export default {
  name: 'Comandos',
  head: { title: { inner: 'Comandos' } },
  components: {
    VueMarkdown
  },
  data () {
    return {
      categories: null,
      commandSearch: '',
      filteredCommands: []
    }
  },
  async mounted () {
    this.categories = await this.$api.commands().then(c => c.categories)
    this.filterCommands()
  },
  computed: {
    nothingFound () {
      return this.filteredCommands.every(c => !c.commands.length)
    }
  },
  methods: {
    getArgType (usage) {
      if (!usage) return []
      const requiredRegex = /(<.[^<>]+>)/g
      const optionalRegex = /(\[.[^[\]]+])/g
      const requiredArgs = usage.split(requiredRegex).map(arg => ({ type: 'obrigatorio', arg }))
      const optionalArgs = usage.split(optionalRegex).map(arg => ({ type: 'opcional', arg }))
      return [
        ...(requiredArgs.filter(({ arg }) => requiredRegex.test(arg))),
        ...(optionalArgs.filter(({ arg }) => optionalRegex.test(arg)))
      ]
    },
    filterCommands () {
      const filterInclude = q => q.toLowerCase().includes(this.commandSearch.toLowerCase())
      const filter = c => filterInclude(c.name) || filterInclude(c.description) || (c.aliases ? c.aliases.find(a => filterInclude(a)) : false)
      const filtered = this.categories.map(c => ({ ...c, commands: c.commands.filter(filter) }))
      this.filteredCommands = this.categories ? filtered : []
    }
  },
  created () {
    this.debouncedFilterCommands = _.debounce(this.filterCommands, 500)
  },
  watch: {
    commandSearch () {
      this.debouncedFilterCommands()
    }
  }
}
</script>

<style lang="scss" scoped>
  $blurple: rgb(153, 203, 253);
  $obrigatorio: rgb(233, 105, 105);
  $opcional: rgb(107, 240, 133);
  .category {
    margin-bottom: 60px;
  }
  .hero-body > .container > .title {
    font-weight: 900;
    font-style: italic;
    font-size: 50px;
  }
  .command {
    margin-bottom: 15px;
  }
  #teste {
    float: center;
  }
  .obrigatorio {
    color: $obrigatorio;
  }
  .opcional {
    color: $opcional;
  }
  .notification.is-info {
    background-color: #1e3151;
    color: #fff;
  }
  .notification {
    border-radius: .4em;
    padding: 1.25rem 2.5rem 1.25rem 1.5rem;
    position: relative;
  }
  .command-usage {
    font-family: Consolas, monospace;
    color: $blurple !important;
  }
  .aliase {
    background: rgba(161, 250, 255, 0.15);
    padding: 4px;
    margin-left: 5px;
    font-family: Consolas, monospace;
    border-radius: 5px;
  }
  .subcommands {
    padding-top: 10px;
  }
  .subcommand{
    margin-top: 10px;
    padding-left: 13px;
    border-left: 1px white solid;
  }
</style>
